export default "__VITE_ASSET__Cp7j16of__"